import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layouts/full/shared/loadable/Loadable";
import { RouterName } from "./RouterName";
import { getPrivileges } from "src/helper/privileges";
import CharityHistory from "src/pages/charity/CharityHistory";
import TransactionPage from "src/pages/transactions/transaction-page";

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import("../layouts/full/FullLayout")));
const BlankLayout = Loadable(
  lazy(() => import("../layouts/blank/BlankLayout")),
);
const SettingsPage = Loadable(
  lazy(() => import("src/pages/settings/SettingsPage")),
);
const AddSettingsPage = Loadable(
  lazy(() => import("src/pages/settings/AddSettings")),
);

const AdminsPage = Loadable(lazy(() => import("../pages/admins/admins/view")));
const ReviewsPage = Loadable(
  lazy(() => import("../pages/Reviews/ReviewsPage")),
);
const ListCategoriesPage = Loadable(
  lazy(() => import("../pages/Reviews/ListCategories")),
);
const AddCargoryPage = Loadable(
  lazy(() => import("../pages/Reviews/AddCateogry")),
);

// const ListSubCategoriesPage = Loadable(
//   lazy(() => import("../pages/Reviews/ListSubCategories"))
// );
// const AddSubCargoryPage = Loadable(
//   lazy(() => import("../pages/Reviews/AddSubCateogry"))
// );

const ContactsPage = Loadable(
  lazy(() => import("../pages/Contacts/ContactsPage")),
);
const IssuesPage = Loadable(lazy(() => import("../pages/issues/IssuesPage")));
const AddAdmin = Loadable(
  lazy(() => import("../pages/admins/admins/AddAdmin")),
);
// const Dashboard = Loadable(lazy(() => import("../pages/dashboard/Dashboard")));

const PrivilegesPage = Loadable(
  lazy(() => import("../pages/admins/privileges/view")),
);
const AddPrivilegs = Loadable(
  lazy(() => import("../pages/admins/privileges/AddPrivilegs")),
);
const UsersList = Loadable(lazy(() => import("src/pages/users/UsersList")));
const AddUser = Loadable(lazy(() => import("src/pages/users/AddUser")));
const LogsList = Loadable(lazy(() => import("src/pages/users/LogsList")));

const CarTypesList = Loadable(
  lazy(() => import("src/pages/carTypes/CarTypesList")),
);

const AddCarTypes = Loadable(
  lazy(() => import("src/pages/carTypes/AddCarTypes")),
);
const CarsList = Loadable(lazy(() => import("src/pages/cars/CarsList")));
const AddCar = Loadable(lazy(() => import("src/pages/cars/AddCar")));
const DriverLists = Loadable(
  lazy(() => import("src/pages/drivers/DriverLists")),
);
const DriverStats = Loadable(
  lazy(() => import("src/pages/drivers/DriverStats")),
);

const AddDrivers = Loadable(lazy(() => import("src/pages/drivers/AddDrivers")));
const DriverLocations = Loadable(
  lazy(() => import("src/pages/drivers/DriverLocations")),
);
const DriverSubserviceAssignmentsList = Loadable(
  lazy(() => import("src/pages/drivers/DriverSubserviceAssignmentsList")),
);
const AssignDriverSubservices = Loadable(
  lazy(() => import("src/pages/drivers/AssignDriverSubservices")),
);

const CharityList = Loadable(
  lazy(() => import("src/pages/charity/CharityList")),
);
const AddCharity = Loadable(lazy(() => import("src/pages/charity/AddCharity")));
const PreferenceTypes = Loadable(
  lazy(() => import("src/pages/preferenceType/PreferenceTypes")),
);
const PreferenceName = Loadable(
  lazy(() => import("src/pages/preferenceType/PreferenceName")),
);
const AddPreferenceTypes = Loadable(
  lazy(() => import("src/pages/preferenceType/AddPreferenceTypes")),
);

const AddPreferenceName = Loadable(
  lazy(() => import("src/pages/preferenceType/AddPreferenceName")),
);
const ClientLoyalty = Loadable(
  lazy(() => import("src/pages/client-loyalty/ClientLoyalty")),
);
const AddClientLoyalty = Loadable(
  lazy(() => import("src/pages/client-loyalty/AddClientLoyalty")),
);
const ListAdditionalCharges = Loadable(
  lazy(() => import("src/pages/additional-charges/ListAdditionalCharges")),
);
const AddAdditionalCharges = Loadable(
  lazy(() => import("src/pages/additional-charges/AddAdditionalCharges")),
);

const ClientAddressLists = Loadable(
  lazy(() => import("src/pages/client-address/ClientAddressLists")),
);

const OrderLists = Loadable(lazy(() => import("src/pages/order/OrderLists")));
const QuotesList = Loadable(lazy(() => import("src/pages/order/QuotesList")));
const ViewOrder = Loadable(lazy(() => import("src/pages/order/ViewOrder")));
const ScheduledOrders = Loadable(
  lazy(() => import("src/pages/order/ScheduledOrder")),
);
const AddOrder = Loadable(lazy(() => import("src/pages/order/AddOrder")));
const ZoneArea = Loadable(lazy(() => import("src/pages/zone/view")));
const AddZone = Loadable(lazy(() => import("src/pages/zone/AddZone")));
const Login = Loadable(
  lazy(() => import("../views/authentication/auth/Login")),
);

const Error = Loadable(lazy(() => import("../views/authentication/Error")));
const Maintenance = Loadable(
  lazy(() => import("../views/authentication/Maintenance")),
);

const DashboardPage = Loadable(
  lazy(() => import("src/pages/dashboard/Dashboard")),
);
const HomePageComponent = Loadable(
  lazy(() => import("src/pages/landingPage/HomePageComponent")),
);

const TeamPage = Loadable(lazy(() => import("src/pages/team/TeamList")));
const AddTeamPage = Loadable(lazy(() => import("src/pages/team/AddTeam")));
const TestimonialsPage = Loadable(
  lazy(() => import("src/pages/testimonials/TestimonialsList")),
);
const AddTestimonialsPage = Loadable(
  lazy(() => import("src/pages/testimonials/AddTestimonials")),
);
const ContactFormPage = Loadable(
  lazy(() => import("src/pages/landingPage/ContactFormList")),
);
const BroadCastComponent = Loadable(
  lazy(() => import("src/pages/broadCast/BroadCastComponent")),
);

const CarsMakeList = Loadable(lazy(() => import("src/pages/car-make/view")));
const AddCarMake = Loadable(
  lazy(() => import("src/pages/car-make/AddCarMake")),
);

const CarsModelList = Loadable(lazy(() => import("src/pages/car-model/view")));
const AddCarModel = Loadable(
  lazy(() => import("src/pages/car-model/AddCarModel")),
);

const BlogPage = Loadable(lazy(() => import("src/pages/landingPage/BlogPage")));
const PromoCodePage = Loadable(
  lazy(() => import("src/pages/promo-codes/promo-code-page")),
);
const CreatePromoCode = Loadable(
  lazy(() => import("src/pages/promo-codes/create-promo-code")),
);
const PartnerPage = Loadable(
  lazy(() => import("src/pages/partners/partner-page")),
);
const CreatePartner = Loadable(
  lazy(() => import("src/pages/partners/create-partner")),
);
const LoyaltyList = Loadable(
  lazy(() => import("src/pages/loyalty-pages/loyalty/loyalty-list")),
);
const CreateLoyalty = Loadable(
  lazy(() => import("src/pages/loyalty-pages/loyalty/create-loyalty")),
);
const LoyaltyPointsList = Loadable(
  lazy(() =>
    import("src/pages/loyalty-pages/loyalty-points/loyalty-points-list"),
  ),
);
const RedeemPointsList = Loadable(
  lazy(() =>
    import("src/pages/loyalty-pages/redeem-loyalty-points/redeem-points.list"),
  ),
);

const BadgesList = Loadable(lazy(() => import("src/pages/badges/badges-list")));
const CreateBadge = Loadable(
  lazy(() => import("src/pages/badges/create-badge")),
);
const DriverVideo = Loadable(
  lazy(() => import("src/pages/landingPage/driver-video")),
);
const TierList = Loadable(lazy(() => import("src/pages/tier/tier-list")));
const ServicesList = Loadable(
  lazy(() => import("src/pages/services/ServicesList")),
);
const AddService = Loadable(lazy(() => import("src/pages/services/AddService")));
const SubservicesList = Loadable(
  lazy(() => import("src/pages/subservices/SubservicesList")),
);
const AddSubservice = Loadable(
  lazy(() => import("src/pages/subservices/AddSubservice")),
);

let data = getPrivileges();

const Router = [
  {
    path: "/",
    element: <FullLayout />,
    children: [
      data["badges"]?.access_read === 1 && {
        path: RouterName.badges.badges,
        exact: true,
        element: <BadgesList />,
      },

      data["transactions"]?.access_read === 1 && {
        path: RouterName.transcation.transcation,
        exact: true,
        element: <TransactionPage />,
      },

      data["badges"]?.access_write === 1 && {
        path: `${RouterName.badges.createBadge}/:id?`,
        exact: true,
        element: <CreateBadge />,
      },
      data["tiers"]?.access_read === 1 && {
        path: RouterName.tier.tier,
        exact: true,
        element: <TierList />,
      },

      data["loyalties"]?.access_read === 1 && {
        path: RouterName.loyalty.loyalty,
        exact: true,
        element: <LoyaltyList />,
      },
      data["loyalties"]?.access_write === 1 && {
        path: RouterName.loyalty.createLoyalty,
        exact: true,
        element: <CreateLoyalty />,
      },
      data["loyalty_points"]?.access_read === 1 && {
        path: RouterName.loyalty.loyaltyPoints,
        exact: true,
        element: <LoyaltyPointsList />,
      },
      data["loyalty_points"]?.access_read === 1 && {
        path: RouterName.loyalty.redeemLoyalty,
        exact: true,
        element: <RedeemPointsList />,
      },
      data["promo_codes"]?.access_read === 1 && {
        path: RouterName.promoCode.promoCode,
        exact: true,
        element: <PromoCodePage />,
      },
      data["promo_codes"]?.access_write === 1 && {
        path: RouterName.promoCode.createPromoCode,
        exact: true,
        element: <CreatePromoCode />,
      },
      data["partners"]?.access_read === 1 && {
        path: RouterName.partner.partner,
        exact: true,
        element: <PartnerPage />,
      },
      data["partners"]?.access_write === 1 && {
        path: RouterName.partner.createPartner,
        exact: true,
        element: <CreatePartner />,
      },
      data["website"]?.access_read === 1 && {
        path: RouterName.landiangPage.homepage,
        exact: true,
        element: <HomePageComponent />,
      },
      data["contactForm"]?.access_read === 1 && {
        path: RouterName.landiangPage.contactForm,
        exact: true,
        element: <ContactFormPage />,
      },
      data["team"]?.access_read === 1 && {
        path: RouterName.landiangPage.team,
        exact: true,
        element: <TeamPage />,
      },
      data["team"]?.access_read === 1 && {
        path: `${RouterName.landiangPage.createTeam}/:id?`,
        exact: true,
        element: <AddTeamPage />,
      },
      data["testimonial"]?.access_read === 1 && {
        path: RouterName.landiangPage.testimonials,
        exact: true,
        element: <TestimonialsPage />,
      },
      data["testimonial"]?.access_read === 1 && {
        path: `${RouterName.landiangPage.createTestimonials}/:id?`,
        exact: true,
        element: <AddTestimonialsPage />,
      },
      data["blog"]?.access_read === 1 && {
        path: `${RouterName.landiangPage.blog}`,
        exact: true,
        element: <BlogPage />,
      },
      data["website"]?.access_read === 1 && {
        path: `${RouterName.landiangPage.driverVideo}`,
        exact: true,
        element: <DriverVideo />,
      },
      data["dashboard"]?.access_read === 1 && {
        path: RouterName.home.home,
        exact: true,
        element: <DashboardPage />,
      },
      data["admins"]?.access_read === 1 && {
        path: RouterName.admins.admins,
        exact: true,
        element: <AdminsPage />,
      },
      (data["admins"]?.access_write === 1 ||
        data["admins"]?.access_edit === 1) && {
        path: `${RouterName.admins.addAdmins}/:id?`,
        exact: true,
        element: <AddAdmin />,
      },
      data["admins"]?.access_read === 1 && {
        path: `${RouterName.privileges.privileges}`,
        exact: true,
        element: <PrivilegesPage />,
      },
      (data["admins"]?.access_write === 1 ||
        data["admins"]?.access_edit === 1) && {
        path: `${RouterName.privileges.addPrivileges}/:id?`,
        exact: true,
        element: <AddPrivilegs />,
      },
      data["car_types"]?.access_read === 1 && {
        path: "/car-types",
        exact: true,
        element: <CarTypesList />,
      },
      (data["car_types"]?.access_write === 1 ||
        data["car_types"]?.access_edit === 1) && {
        path: "/car-types/create/:id?",
        exact: true,
        element: <AddCarTypes />,
      },
      data["cars"]?.access_read === 1 && {
        path: "/cars",
        exact: true,
        element: <CarsList />,
      },
      (data["cars"]?.access_write === 1 ||
        data["cars"]?.access_edit === 1) && {
        path: "/cars/create/:id?",
        exact: true,
        element: <AddCar />,
      },

      data["cars"]?.access_read === 1 && {
        path: "/make",
        exact: true,
        element: <CarsMakeList />,
      },

      data["cars"]?.access_read === 1 && {
        path: "/model",
        exact: true,
        element: <CarsModelList />,
      },

      (data["cars"]?.access_write === 1 ||
        data["cars"]?.access_edit === 1) && {
        path: "/make/create/:id?",
        exact: true,
        element: <AddCarMake />,
      },
      (data["cars"]?.access_write === 1 ||
        data["cars"]?.access_edit === 1) && {
        path: "/model/create/:id?",
        exact: true,
        element: <AddCarModel />,
      },

      data["drivers"]?.access_read === 1 && {
        path: "/drivers",
        exact: true,
        element: <DriverLists />,
      },
      data["drivers"]?.access_read === 1 && {
        path: "/drivers/stats/:id?",
        exact: true,
        element: <DriverStats />,
      },

      (data["drivers"]?.access_write === 1 ||
        data["drivers"]?.access_edit === 1) && {
        path: "/drivers/create/:id?",
        exact: true,
        element: <AddDrivers />,
      },
      data["drivers"]?.access_read === 1 && {
        path: "/drivers/location",
        exact: true,
        element: <DriverLocations />,
      },
      data["drivers"]?.access_read === 1 && {
        path: RouterName.driver.driverSubserviceAssignments,
        exact: true,
        element: <DriverSubserviceAssignmentsList />,
      },
      (data["drivers"]?.access_write === 1 ||
        data["drivers"]?.access_edit === 1) && {
        path: `${RouterName.driver.assignDriverSubservice}/:driverId?`,
        exact: true,
        element: <AssignDriverSubservices />,
      },
      data["charities"]?.access_read === 1 && {
        path: `/charity`,
        exact: true,
        element: <CharityList />,
      },
      data["charity_history"]?.access_read === 1 && {
        path: `/charity/history`,
        exact: true,
        element: <CharityHistory />,
      },
      (data["charities"]?.access_write === 1 ||
        data["charities"]?.access_edit === 1) && {
        path: "/charity/create/:id?",
        exact: true,
        element: <AddCharity />,
      },

      data["services"]?.access_read === 1 && {
        path: RouterName.services.services,
        exact: true,
        element: <ServicesList />,
      },
      (data["services"]?.access_write === 1 ||
        data["services"]?.access_edit === 1) && {
        path: `${RouterName.services.createService}/:id?`,
        exact: true,
        element: <AddService />,
      },
      data["subservices"]?.access_read === 1 && {
        path: RouterName.subservices.subservices,
        exact: true,
        element: <SubservicesList />,
      },
      (data["subservices"]?.access_write === 1 ||
        data["subservices"]?.access_edit === 1) && {
        path: `${RouterName.subservices.createSubservice}/:id?`,
        exact: true,
        element: <AddSubservice />,
      },

      data["preference_types"]?.access_read === 1 && {
        path: "/preference-type",
        exact: true,
        element: <PreferenceTypes />,
      },
      (data["preference_types"]?.access_write === 1 ||
        data["preference_types"]?.access_edit === 1) && {
        path: "/preference-type/create/:id?",
        exact: true,
        element: <AddPreferenceTypes />,
      },

      data["preferences"]?.access_read === 1 && {
        path: "/preference",
        exact: true,
        element: <PreferenceName />,
      },
      (data["preferences"]?.access_write === 1 ||
        data["preferences"]?.access_edit === 1) && {
        path: "/preference/create/:id?",
        exact: true,
        element: <AddPreferenceName />,
      },

      data["client_loyalties"]?.access_read === 1 && {
        path: "/loyalty",
        exact: true,
        element: <ClientLoyalty />,
      },
      (data["client_loyalties"]?.access_write === 1 ||
        data["client_loyalties"]?.access_edit === 1) && {
        path: "/loyalty/create/:id?",
        exact: true,
        element: <AddClientLoyalty />,
      },
      data["additional_fees"]?.access_read === 1 && {
        path: "/additional-charge",
        exact: true,
        element: <ListAdditionalCharges />,
      },
      (data["additional_fees"]?.access_write === 1 ||
        data["additional_fees"]?.access_edit === 1) && {
        path: "/additional-charge/create/:id?",
        exact: true,
        element: <AddAdditionalCharges />,
      },
      data["zones"]?.access_read === 1 && {
        path: "/zone",
        exact: true,
        element: <ZoneArea />,
      },
      (data["zones"]?.access_write === 1 ||
        data["zones"]?.access_edit === 1) && {
        path: "/zone/create/:id?",
        exact: true,
        element: <AddZone />,
      },
      data["users"]?.access_read === 1 && {
        path: "/client",
        exact: true,
        element: <UsersList />,
      },
      (data["users"]?.access_write === 1 ||
        data["users"]?.access_edit === 1) && {
        path: "/client/create/:id?",
        exact: true,
        element: <AddUser />,
      },
      data["user_logs"]?.access_read === 1 && {
        path: "/logs",
        exact: true,
        element: <LogsList />,
      },
      data["users"]?.access_read === 1 && {
        path: "/client/:id/address",
        exact: true,
        element: <ClientAddressLists />,
      },
      data["orders"]?.access_read === 1 && {
        path: "/order",
        exact: true,
        element: <OrderLists />,
      },
      data["orders"]?.access_read === 1 && {
        path: RouterName.order.quotes,
        exact: true,
        element: <QuotesList />,
      },
      data["orders"]?.access_read === 1 && {
        path: "/order/view/:id",
        exact: true,
        element: <ViewOrder />,
      },
      data["orders"]?.access_read === 1 && {
        path: "/order/scheduled",
        exact: true,
        element: <ScheduledOrders />,
      },
      (data["orders"]?.access_write === 1 ||
        data["orders"]?.access_edit === 1) && {
        path: "/order/create/:id?",
        exact: true,
        element: <AddOrder />,
      },
      data["broadcast"]?.access_read === 1 && {
        path: RouterName.broadCast.broadCast,
        exact: true,
        element: <BroadCastComponent />,
      },
      data["reviews"]?.access_read === 1 && {
        path: "/reviews",
        exact: true,
        element: <ReviewsPage />,
      },

      data["reviews"]?.access_read === 1 && {
        path: "/reviews/list-categories",
        exact: true,
        element: <ListCategoriesPage />,
      },
      data["reviews"]?.access_read === 1 && {
        path: "/reviews/create-category/:id?",
        exact: true,
        element: <AddCargoryPage />,
      },
      // data["reviews"]?.access_read === 1 && {
      //   path: "/reviews/list-subcategories",
      //   exact: true,
      //   element: <ListSubCategoriesPage />,
      // },
      // data["reviews"]?.access_read === 1 && {
      //   path: "/reviews/create-subcategory",
      //   exact: true,
      //   element: <AddSubCargoryPage />,
      // },

      data["contacts"]?.access_read === 1 && {
        path: "/contacts",
        exact: true,
        element: <ContactsPage />,
      },
      // data["issues"]?.access_read === 1 && {
      //   path: "/issues",
      //   exact: true,
      //   element: <IssuesPage />,
      // },
      data["settings"]?.access_read === 1 && {
        path: "/settings",
        exact: true,
        element: <SettingsPage />,
      },

      data["settings"]?.access_read === 1 && {
        path: "/settings",
        exact: true,
        element: <SettingsPage />,
      },
      (data["settings"]?.access_write === 1 ||
        data["settings"]?.access_edit === 1) && {
        path: "/settings/create/:id?",
        exact: true,
        element: <AddSettingsPage />,
      },

      { path: "/404", element: <Error /> },
      { path: "*", element: <Navigate to="/" /> },
    ],
  },
  {
    path: "/",
    element: <BlankLayout />,
    children: [
      { path: "/auth/404", element: <Error /> },
      { path: RouterName.auth.login, element: <Login /> },
      { path: RouterName.auth.maintenance, element: <Maintenance /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
